import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { projectsAtom } from '../v0/projectAtoms';

// 存储最近使用的项目ID（最多5个）
export const recentProjectIdsAtom = atomWithStorage<string[]>('v3_recent_project_ids', []);

// 添加项目ID到最近使用列表
export const addRecentProjectIdAtom = atom(
  null,
  (get, set, projectId: string) => {
    const recentIds = get(recentProjectIdsAtom);
    
    // 如果ID已存在，先移除它
    const filteredIds = recentIds.filter(id => id !== projectId);
    
    // 将ID添加到列表开头
    const newIds = [projectId, ...filteredIds].slice(0, 5);
    
    // 更新存储
    set(recentProjectIdsAtom, newIds);
  }
);

// 获取最近使用的项目（带有完整项目信息）
export const recentProjectsAtom = atom(get => {
  const recentIds = get(recentProjectIdsAtom);
  const allProjects = get(projectsAtom);
  
  // 按照recentIds的顺序返回项目
  return recentIds
    .map(id => allProjects.find(project => project.id === id))
    .filter(Boolean); // 过滤掉undefined
});

// 获取推荐的项目（最近使用的或任务最多的）
export const recommendedProjectsAtom = atom(get => {
  const recentProjects = get(recentProjectsAtom);
  const allProjects = get(projectsAtom);
  
  // 如果有最近使用的项目，返回它们
  if (recentProjects.length > 0) {
    return recentProjects.slice(0, 3);
  }
  
  // 否则返回前3个项目（通常按创建时间排序）
  return allProjects.slice(0, 3);
});
